import { UseAuth } from "hook/auth-hook";
import { TokenAuthenticationFactory } from "pages/factory/safety/token-authentication-factory";
import { Route, Routes, useLocation } from "react-router-dom";
import Private from "./private-route";
import Public from "./public-route";

export function AppRoutes() {
    const { isLoggedIn } = UseAuth();
    const location = useLocation();

    if (location.pathname === "/auth/token" || location.pathname === "/auth/autologin") {
        return (
            <Routes>
                <Route path="/auth/token" element={<TokenAuthenticationFactory />} />
                <Route path="/auth/autologin" element={<TokenAuthenticationFactory />} />
            </Routes>
        );
    }

    return !isLoggedIn ? <Public /> : <Private />;
}

export default AppRoutes
